interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: React.ReactNode;
  trend?: {
    value: number;
    label: string;
  };
  color?: "blue" | "green" | "purple" | "yellow" | "red";
}

// Only the icon takes a tint; the value stays neutral so the row reads as one set
const iconTint: Record<NonNullable<StatsCardProps["color"]>, string> = {
  blue: "text-blue-400",
  green: "text-green-400",
  purple: "text-blue-400",
  yellow: "text-yellow-400",
  red: "text-red-400",
};

export function StatsCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  color = "blue",
}: StatsCardProps) {
  return (
    <div className="card flex items-start justify-between gap-3">
      <div className="min-w-0 space-y-1">
        <p className="text-sm text-gray-400">{title}</p>
        <p className="num text-2xl font-semibold text-gray-50 tracking-tight">
          {value}
        </p>
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
        {trend && (
          <p className="text-xs">
            <span
              className={`num ${
                trend.value >= 0 ? "text-green-400" : "text-red-400"
              }`}
            >
              {trend.value >= 0 ? "+" : ""}
              {trend.value}%
            </span>{" "}
            <span className="text-gray-500">{trend.label}</span>
          </p>
        )}
      </div>
      <div
        className={`shrink-0 p-2.5 rounded-lg bg-gray-700/70 ${iconTint[color]}`}
      >
        {icon}
      </div>
    </div>
  );
}
